import React, { CSSProperties, KeyboardEvent } from "react";
import { Input, Modal, IconButton, Typography, Button } from "material-ui";
import Close from "material-ui-icons/Close";
import Backspace from "material-ui-icons/KeyboardBackspace";
import logger from "util/logger";
import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";

export interface CodeLoginProps {
    title: string;
    description: string;
    onClose: () => void;
    submit: (
        code: string,
        success: Function,
        error: (error: string) => void
    ) => void;
    showSkip: boolean;
}
export interface CodeLoginState {
    isOpen: boolean;
    isValid: boolean;
    errorMessage: string;
    loading: boolean;
}

export class CodeDialog extends React.Component<
    CodeLoginProps,
    CodeLoginState
> {
    constructor(props: CodeLoginProps) {
        super(props);
        this.state = {
            isOpen: true,
            isValid: true,
            errorMessage: "",
            loading: false,
        };
    }
    input1: HTMLInputElement;
    input2: HTMLInputElement;
    input3: HTMLInputElement;
    input4: HTMLInputElement;
    inputs: HTMLInputElement[] = [
        this.input1,
        this.input2,
        this.input3,
        this.input4,
    ];

    // height = 220;
    // heightOffset = this.height / 2;
    code = "";

    styles: CSSProperties = {
        inputStyle: {
            height: 48,
            width: 48,
            color: "#000",
            backgroundColor: "#fff",
            borderRadius: 5,
            borderColor: "#000",
            padding: 8,
            margin: 8,
        },
        inputElemStyles: {
            textAlign: "center",
            fontSize: 30,
        },
        modal: {
            width: "100%",
            height: "100%",
        },
        paper: {
            textAlign: "center",
            backgroundColor: "#fff",
            padding: 8,
            paddingBottom: 16,
            width: "100%",
        },
        inputContainer: {
            display: "flex",
            justifyContent: "center",
            marginBottom: 24,
        },
        iconButton: {
            position: "absolute",
            right: 4,
            top: 4,
            color: "#3a649e",
        },
        headerStyle: {
            color: "#3a649e",
            fontFamily: "Raleway , sans-serif",
        },
        skipButton: {
            color: "#3a649e",
            fontSize: "1em",
            fontWeight: 200,
        },
        roundKey: {
            width: "33%",
            height: "25%",
            fontSize: "1.5em",
            fontWeight: 200,
        },
        virtualKeyboard: {
            width: "100%",
            height: "50%",
            position: "fixed",
            bottom: 0,
            display: "flex",
            flexWrap: "wrap",
        },
    };

    submit() {
        if (this.code.length === 4) {
            this.setState({ ...this.state, loading: true });
            this.props.submit(
                this.code,
                () => {
                    this.setState({
                        ...this.state,
                        isOpen: false,
                        isValid: true,
                        errorMessage: "",
                        loading: false,
                    });
                },
                (error) => {
                    this.setState({
                        ...this.state,
                        isValid: false,
                        errorMessage: error,
                        loading: false,
                    });
                }
            );
        }
    }

    handleKeyEvent(inputIndex: number, event: KeyboardEvent<HTMLInputElement>) {
        event.preventDefault();
        let key = event.key;
        if (
            key === "Backspace" ||
            key === "KEYCODE_DEL" ||
            key === "kVK_Delete" ||
            key === "VK_BACK" ||
            key === "GDK_KEY_BackSpace"
        ) {
            this.code = this.code.substr(0, inputIndex);
            this.inputs[inputIndex].value = "";
            if (inputIndex > 0) {
                this.inputs[inputIndex - 1].focus();
            }
        } else {
            this.code += key;
            this.inputs[inputIndex].value = "*";
            if (inputIndex < this.inputs.length - 1) {
                this.inputs[inputIndex + 1].focus();
            } else {
                this.submit();
            }
        }
    }

    createInputElements() {
        return (
            <div className="inputContainer" style={this.styles.inputContainer}>
                {this.inputs.map((val, index) => {
                    return (
                        <Input
                            error={!this.state.isValid}
                            key={index}
                            disabled={true}
                            autoFocus={index === 0}
                            style={this.styles.inputStyle}
                            inputRef={(c) => (this.inputs[index] = c!)}
                            type="tel"
                            inputProps={{
                                maxLength: 1,
                                style: this.styles.inputElemStyles,
                                onKeyDown: (
                                    event: KeyboardEvent<HTMLInputElement>
                                ) => this.handleKeyEvent(index, event),
                            }}
                        />
                    );
                })}
            </div>
        );
    }

    inputButtonClicked(val: Number) {
        if (val === -2) {
            this.setState({ ...this.state, isOpen: false });
            this.props.onClose();
        }
        let index = this.code.length > 0 ? this.code.length - 1 : 0;
        if (val === -1) {
            this.code = this.code.substr(0, index);
            logger.info(index);
            this.inputs[index].value = "";
        } else if (this.code.length < 4) {
            this.code += val;
            let current = this.code.length - 1;
            this.inputs[current].value = "*";
            if (current === this.inputs.length - 1) {
                this.submit();
            }
        }
    }

    renderKeyboard() {
        let buttons = [];
        for (let index = 1; index < 10; index++) {
            buttons.push({
                id: `key_${index}`,
                value: index,
                label: `${index}`,
            });
        }
        buttons.push({
            id: `key_backspace`,
            value: -1,
            label: "Poista merkki",
        });
        buttons.push({ id: `key_0`, value: 0, label: `0` });
        if (this.props.showSkip) {
            buttons.push({ id: `key_done`, value: -2, label: "Ohita" });
        } else {
            buttons.push({ id: `key_done`, value: -5, label: "" });
        }
        return (
            <div
                className="virtualKeyboard"
                style={this.styles.virtualKeyboard}
            >
                {buttons.map((val, index) => {
                    return (
                        <Button
                            aria-label={val.label}
                            className="roundKey"
                            style={
                                val.value === -2
                                    ? {
                                          ...this.styles.roundKey,
                                          ...this.styles.skipButton,
                                      }
                                    : this.styles.roundKey
                            }
                            id={val.id}
                            disabled={val.value === -5}
                            onClick={() => this.inputButtonClicked(val.value)}
                            key={index}
                        >
                            {(val.value === -1 && <Backspace />) || val.label}
                        </Button>
                    );
                })}
            </div>
        );
    }

    render() {
        return (
            <Modal
                open={this.state.isOpen}
                onClose={() => {
                    this.setState({ ...this.state, isOpen: false });
                    this.props.onClose();
                }}
                style={this.styles.modal}
                disableBackdropClick={true}
            >
                <div style={this.styles.paper} className="paper">
                    <FullPageSpinner loading={this.state.loading} />
                    <div className="header">
                        {" "}
                        <h2 style={this.styles.headerStyle}>
                            {this.props.title}
                        </h2>
                        <IconButton
                            style={this.styles.iconButton}
                            aria-label={"Sulje"}
                            onClick={() => {
                                this.setState({ ...this.state, isOpen: false });
                                this.props.onClose();
                            }}
                        >
                            <Close />
                        </IconButton>
                    </div>
                    <div className="description">
                        <Typography>{this.props.description}</Typography>
                    </div>
                    {this.createInputElements()}
                    {!this.state.isValid && (
                        <div className="code-input-errors">
                            {this.state.errorMessage}
                        </div>
                    )}
                    {this.renderKeyboard()}
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/login/components/CodeDialog.tsx